export default "__VITE_ASSET__7b9db90c__"